<div class="container-fluid">
  <p class="alert alert-success m-3">Version update page is in progress</p>
</div>
